import React from "react";
import { DialogModalWindow } from "src/components/shared";
import { QUESTION_LIBRARY, QUESTION_TYPE_LABELS } from "src/util/utils";
import "./QuestionBrowser.scss";

export const QuestionBrowser = ({ isOpen, onClose, onSelectQuestion }) => {
  return (
    <DialogModalWindow
      isOpen={isOpen}
      title="Select a question from the use cases below:"
      onCancel={onClose}
      cancelBtn={false}
      confirmBtn={false}
    >
      <div className="question-browser" style={{textAlign: 'left'}}>
        {QUESTION_LIBRARY.map((c, index) => (
          <div key={index} className="group">
            <div className="category">{c.category}</div>
            {c.questions.map((q, index) => (
              <div key={index} className="question" onClick={() => onSelectQuestion(q.question, q.type)}>
                <div>"{q.question}"</div>
                <span className="question-type">{QUESTION_TYPE_LABELS[q.type]}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </DialogModalWindow>
  );
};

export default QuestionBrowser;
